module.exports = __webpack_public_path__ + "static/add-to-jam-page-4c7d57c124013bae1364a3349b82180d.png";